import http from "@/http/aisea/axios";
const resource = "/enterprise/cameras";

export default {
  search() {
    return http.get(`${resource}`);
  },

  fetchVesselCameras(vesselId) {
    return http.get(`/enterprise/vessels/${vesselId}/cameras`);
  },

  connect(cameraId) {
    return http.post(`${resource}/${cameraId}/connect`);
  },

  hykeCamGetMedia(payload) {
    return http.get(`${resource}/${payload.cameraId}/hykecam_getmedia`);
  },

  connectHLS(cameraId) {
    return http.get(`${resource}/${cameraId}/connect/hls`);
  },

  connectOnDemand(cameraId, payload) {
    return http.get(`${resource}/${cameraId}/connect/ondemand`, {
      params: payload,
    });
  },

  onDemandByHash(cameraHash, payload) {
    return http.get(`${resource}/${cameraHash}/OnDemand.m3u8`, {
      params: payload,
    });
  },

  updateSortOrder(payload) {
    return http.put(`${resource}/sort_order`, payload);
  },
};
